import { useStore } from "effector-react"
import { useState } from "react"
import { useHistory } from "react-router"
import { $demands } from "../../../../pages/demands/logics/demands"
import { INotification, setCurrentNotification } from "../logics/notificationsLogic"

interface INotificationItem {
    notify: INotification
    setOpenMenu:React.Dispatch<React.SetStateAction<boolean>>
}
export const NotificationItem = ({ notify,setOpenMenu }: INotificationItem) => {
    const [spanned, setSpanned] = useState(false)
    const history = useHistory()
    const {allDems} = useStore($demands)
    const activitySwitcher = (activity: string) => {
        switch (activity) {
            case "claims":
                return "Заявки"
            case "orders":
                return "Заявки"
            case "news":
                return "Новости"
            case "pay":
                return "Задолженность"
            case "charges":
                return "Начисления"
            case "registers":
                return "Счётчики"
            default:
                return ""
        }
    }
    const formatDate = (date: string) => {
        return date.replace(/-/gi, '.').substring(0, 16)
    }
    const formatTitle = (notify: INotification) => {
        let titleParts = notify.title.split("№")
        let demandId = 0
        if (notify.data) {
            if (notify.activity === "orders") {
                demandId = JSON.parse(notify.data).order_id
            }
            else {
                demandId = JSON.parse(notify.data).claim_id
            }
        }
        let order = allDems.find(e=>e.id?.toString() === demandId?.toString())?.order
        return <p>{titleParts[0]}<span style={{ cursor: 'pointer', color:"blue" }} 
        onClick={() => {
           setCurrentNotification(demandId)
           setOpenMenu(false)
          if(order===0){
              history.push("/order/free")
          }else{
            history.push("/order/pay")
          }
        }}
        >№{titleParts[1]}</span> </p>
    }
    return (
        <div style={{ padding: " 0 0.5rem" }}>
            <p style={{ fontWeight: 700, lineHeight: "1rem", marginBottom: "0.5rem", wordBreak:"break-all" }}>
                {notify.activity === "claims" || notify.activity === "orders" ?
                    formatTitle(notify)
                    : notify.title}
            </p>
            <p onClick={() => setSpanned(!spanned)} style={{ cursor: "pointer", textAlign: 'justify', fontSize: "0.8rem", lineHeight: "1rem", marginBottom: 0 }}>{!spanned ?
                notify.body.length > 120 ? `${notify.body.slice(0, 120)}...` : notify.body :
                notify.body}</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: "0.5rem" }}>
                <span style={{ fontSize: "0.8rem", opacity: 0.7 }}>{formatDate(notify.dt)}</span>
                <span style={{ fontSize: "0.8rem", opacity: 0.7 }}>{activitySwitcher(notify.activity)}</span>
            </div>
            <hr></hr>
        </div>
    )
}